{
  "not_found": "Could not load the hiring template",
  "add_employee": "Add employee",
  "title": "Hiring templates",
  "new_template": "New hiring template",
  "copy_from": "Copy settings from (optional)",
  "select_template": "Select a template",
  "copy_hint": "Settings will be copied to the new template. You can change them later.",
  "last_updated": "Last updated",
  "archive_confirm": "Archive the template “{title}”?",
  "main": "Main",
  "personal": "Personal details",
  "onboarding": "Onboarding setup",
  "add_section": "Add section",
  "rename_section": "Rename",
  "system_section_title_reset_hint": "Default name: {title}",
  "delete_section": "Delete section",
  "make_optional": "Make optional",
  "make_mandatory": "Make mandatory",
  "hide_field": "Hide from form",
  "show_field": "Show in form",
  "optional": "Optional",
  "disabled": "Disabled",
  "can_change": "Can be changed",
  "cannot_change": "Can't be changed",
  "compensation_after_probation": "Compensation after probation is",
  "will_be_launched_and": "will be launched and",
  "saved": "Template saved",
  "section_position": "Work info",
  "section_employment": "Employment",
  "section_compensation": "Compensation",
  "section_employee_basic_info_manager": "Manager",
  "section_employee_basic_info_personal": "Personal details",
  "section_employee_basic_info_contacts": "Contacts",
  "section_employee_basic_info_address": "Address",
  "section_employee_basic_info_hired_via_job": "Hiring details",
  "section_custom": "Section",
  "preview_form": "Preview form",
  "preview_hint": "Preview mode: no employee will be created and no changes will be saved.",
  "preview_complete": "Preview complete",
  "hire_queued": "Hiring is in progress",
  "hire_queued_hint": "This usually takes a few seconds. The employee profile will open automatically.",
  "hire_failed": "Could not submit the hiring form. Please try again.",
  "new_employee_from_this": "New employee from this",
  "probation_date_invalid": "The probation end date cannot be before the start date.",
  "compensation_after_probation_title": "Compensation after probation",
  "hire_job_failed": "Could not hire the employee. Please try again.",
  "hire_status_unknown": "Could not get the hiring status",
  "hire_status_unknown_hint": "Hiring may still be in progress. Check the employee directory in a few minutes before trying again.",
  "go_to_employees": "Go to employees"
}
